import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import DescriptionLink from 'scenes/Cms/components/DescriptionLink'
import { getImageUrl } from 'slices/Cms/Content/AppNavigation/BottomNav/helpers'
import { NavigationTab } from 'slices/Cms/Content/AppNavigation/BottomNav/types'

const t = buildTranslate('cms.content.app_navigation.bottom_nav.tab')

type Props = {
  tab: NavigationTab
}

const Content: React.FC<Props> = ({ tab }) => {
  const [css] = useStyletron()

  return (
    <div className="d-flex align-items-start">
      {/* Tab Details */}
      <div className="flex-grow-1">
        {/* Default Icon */}
        <div className="me-l">
          <Text.BodyText4
            tag="h3"
            color="grey90"
            className="mb-s font-weight-bold"
          >
            {t('icon_default')}
          </Text.BodyText4>
          <div
            className={`d-flex align-items-center justify-content-center mb-s ${css(
              {
                width: '40px',
                height: '40px',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                backgroundColor: tab.default_icon ? 'transparent' : '#f9f9f9',
              }
            )}`}
          >
            {tab.default_icon ? (
              <img
                src={getImageUrl(tab.default_icon) || ''}
                alt="Default icon"
                className={css({ width: '24px', height: '24px' })}
              />
            ) : (
              <Text.BodyText4 color="grey50">&#8856;</Text.BodyText4>
            )}
          </div>
        </div>

        {/* Selected Icon */}
        <div>
          <Text.BodyText4
            tag="h3"
            color="grey90"
            className="mb-s font-weight-bold"
          >
            {t('icon_selected')}
          </Text.BodyText4>
          <div
            className={`d-flex align-items-center justify-content-center mb-s ${css(
              {
                width: '40px',
                height: '40px',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                backgroundColor: tab.selected_icon ? 'transparent' : '#f9f9f9',
              }
            )}`}
          >
            {tab.selected_icon ? (
              <img
                src={getImageUrl(tab.selected_icon) || ''}
                alt="Selected icon"
                className={css({ width: '24px', height: '24px' })}
              />
            ) : (
              <Text.BodyText4 color="grey50">&#8856;</Text.BodyText4>
            )}
          </div>
        </div>

        {/* Label */}
        <div className="mb-s">
          <Text.BodyText4>
            <strong>{t('label')}</strong>
          </Text.BodyText4>
          <Text.BodyText4 tag="p" color="grey70" className="mb-0">
            {tab.name}
          </Text.BodyText4>
        </div>

        {/* Link */}
        <DescriptionLink
          url={tab.link}
          className="mb-s"
          brameCampaignId={tab.settings?.brame_campaign_id}
        />
      </div>
    </div>
  )
}

export default Content
